import { api } from '../middleware/api';

export const stamstoreApi = api
  .enhanceEndpoints({ addTagTypes: ['STAMStore'] })
  .injectEndpoints({
    endpoints: builder => ({
      // Stores the signed-in user may use.
      getSTAMStores: builder.query<any[], string>({
        query: cid => `stamstore/${cid}`,
        providesTags: ['STAMStore']
      })
    })
  });

export const { useGetSTAMStoresQuery } = stamstoreApi;
